import React, { useState } from 'react';
import Resizer from 'react-image-file-resizer';

// دالة مساعدة لضغط الصورة وإرجاعها كـ File
export const resizeImageFile = (file, options = {}) => {
  return new Promise((resolve, reject) => {
    const {
      maxWidth = 1024,
      maxHeight = 1024,
      quality = 80,
      outputType = "JPEG",
      rotation = 0
    } = options;

    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      outputType,
      quality,
      rotation,
      (uri) => {
        // تحويل الـ blob إلى File
        if (uri instanceof Blob) {
          const resizedFile = new File([uri], file.name, {
            type: uri.type,
            lastModified: Date.now()
          });
          resolve(resizedFile);
        } else {
          reject(new Error('Failed to resize image'));
        }
      },
      "blob",
      maxWidth,
      maxHeight
    );
  });
};

// دالة لضغط الصورة وعرضها كـ Base64 (للمعاينة)
export const resizeImageToBase64 = (file, options = {}) => {
  return new Promise((resolve, reject) => {
    const {
      maxWidth = 1024,
      maxHeight = 1024,
      quality = 80,
      outputType = "JPEG",
      rotation = 0
    } = options;

    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      outputType,
      quality,
      rotation,
      (uri) => {
        resolve(uri);
      },
      "base64",
      maxWidth,
      maxHeight
    );
  });
};

// Hook مخصص لاستخدام ضغط الصور
export const useImageResizer = () => {
  const [isResizing, setIsResizing] = useState(false);
  const [error, setError] = useState(null);

  const resizeImage = async (file, options = {}) => {
    if (!file) return null;
    
    setIsResizing(true);
    setError(null);
    
    try {
      // التحقق من حجم الملف (إذا كان أكبر من 1MB يتم الضغط)
      const fileSizeMB = file.size / (1024 * 1024);
      const defaultOptions = {
        maxWidth: fileSizeMB > 1 ? 1024 : 2048,
        maxHeight: fileSizeMB > 1 ? 1024 : 2048,
        quality: fileSizeMB > 1 ? 70 : 85,
        outputType: "JPEG",
        rotation: 0
      };
      
      const mergedOptions = { ...defaultOptions, ...options };
      const resizedFile = await resizeImageFile(file, mergedOptions);
      
      // إضافة معلومات عن الضغط
      resizedFile.originalSize = file.size;
      resizedFile.compressedSize = resizedFile.size;
      resizedFile.compressionRatio = ((1 - resizedFile.size / file.size) * 100).toFixed(2);
      
      return resizedFile;
    } catch (err) {
      setError(err.message);
      console.error("Error resizing image:", err);
      return file; // إرجاع الملف الأصلي في حالة الخطأ
    } finally {
      setIsResizing(false);
    }
  };

  return { resizeImage, isResizing, error };
};